import React, { useEffect, useReducer } from 'react';
import GameManager from '../core/GameManager';
import { RouteComponentProps } from 'react-router';

import { createUnityVisualizerInstance, Globals } from '../misc/helpers';
import PracticeScenarioA from '../scenarios/Game/Practice/practiceScenarioA';
import PracticeScenarioB from '../scenarios/Game/Practice/practiceScenarioB';
import PracticeScenarioC from '../scenarios/Game/Practice/practiceScenarioC';
import PracticeScenarioD from '../scenarios/Game/Practice/practiceScenarioD';
import TestScenarioA from '../scenarios/Game/Test/testScenarioA';
import TestScenarioB from '../scenarios/Game/Test/testScenarioB';
import TestScenarioC from '../scenarios/Game/Test/testScenarioC';
import TestScenarioD from '../scenarios/Game/Test/testScenarioD';
import ReactTools from '../core/Misc/ReactTools';
import InGameUI from '../components/InGameUI';
import ReactSoundManager from '../core/ReactSoundManager';

const reducer = (state: any, action: any) => {
	var result = ReactTools.generalReducer(state, action);
	switch (action.type) {
		case 'forceUpdate':
			result = {...state, forceUpdate: !state.forceUpdate};
			break; 
		}
	return result;
};
 
const GamePage = (props: any) => { 
	const [state, dispatch] = useReducer(reducer, {
		gameManager: null,
		forceUpdate: false
	});

	useEffect(() => {
		if(state.gameManager) {
			if(typeof state.gameManager.currentScenarioIndex === 'undefined' || state.gameManager.currentScenarioIndex === null || state.gameManager.currentScenarioIndex === -1) {
				state.gameManager.loadScenario(props.scenarioId);
			}

			if(Globals.markCurrentScenarioAsCompleted) {
				var currentScenario = state.gameManager.scenarios[state.gameManager.currentScenarioIndex];

				currentScenario.aarPassed = true;
				currentScenario.aarCalled911  = true;
				currentScenario.aarWearPPE  = true;
				currentScenario.aarPressureDressing = true;
				currentScenario.aarApplyPressureDressing = true;
				currentScenario.aarApplyPressureWithPD = true;
				currentScenario.aarPressureDressingNotRemoved = true;
				currentScenario.aarReassessAfterPD = true;
				currentScenario.aarApplyFirstTourniquete = true;
				currentScenario.aarTwistFirstTourniqueteRod = true;
				currentScenario.aarReassessAfterFirstTourniquete = true;
				currentScenario.aarRecordTimeOfFirstTourniquete = true;
				currentScenario.aarApplySecondTourniquete = true;
				currentScenario.aarTwistScondTourniqueteRod = true;
				currentScenario.aarReassessAfterSecondTourniquete = true;
				currentScenario.aarRecordTimeOfSecondTourniquete = true;

				if(currentScenario.goToScenarioEnd) {
					currentScenario.goToScenarioEnd();
				}
				Globals.markCurrentScenarioAsCompleted = false;
			}
		} else {
			var gm = new GameManager();
			
			gm.customData = {
				dispatch: dispatch
			};
			var environment = createUnityVisualizerInstance(gm);
			environment.init();
			gm.init([
				new PracticeScenarioA(gm, 'PracticeScenarioA'),
				new PracticeScenarioB(gm, 'PracticeScenarioB'),
				new PracticeScenarioC(gm, 'PracticeScenarioC'),
				new PracticeScenarioD(gm, 'PracticeScenarioD'),
				new TestScenarioA(gm, 'TestScenarioA'),
				new TestScenarioB(gm, 'TestScenarioB'),
				new TestScenarioC(gm, 'TestScenarioC'),
				new TestScenarioD(gm, 'TestScenarioD')
			], environment, new ReactSoundManager(() => {
				dispatch({
					type: 'forceUpdate',
					value: gm
				});
			}), true, '', {});
			dispatch({
				type: 'setGameManager',
				value: gm
			});
		}
	}, [state.gameManager, state.forceUpdate, Globals.markCurrentScenarioAsCompleted]);
  
	return (
		state.gameManager ? (
			<div>
				{state.gameManager.environment.render(() => {
					dispatch({
						type: 'forceUpdate'
					});
				}, {updateWindow: props.updateWindow})}
				<InGameUI updateWindow={props.updateWindow} gameManager={state.gameManager} forceUpdate={() => {
					dispatch({
						type: 'forceUpdate',
						value: state.gameManager
					});
				}}></InGameUI>
			</div>) : (<div>Initialing Page...</div>)
	);
};

export default GamePage;
